<script setup lang="ts">
// No props needed for this container component
</script>

<template>
  <div bg="neutral-50 dark:[rgba(0,0,0,0.3)]" rounded-xl p-4 flex="~ col gap-6">
    <slot />
  </div>
</template>
